// These are the magic strings coming from the backend
// we can use them to map to our own enum value
const KITTING = 51

// enum mapping to the proper i18n text
export const OrderDetailsOrderTypeEnum = {
  default: 'orderType.B2C',
  [KITTING]: 'orderType.Kitting'
}
